/**
 * @generated SignedSource<<afbf22bf31fc590ad1cb027cb7f7b45e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserAdminEditGroupDeviceScreenMutation$variables = {
  id: string;
  name: string;
  storeId?: string | null;
};
export type UserAdminEditGroupDeviceScreenMutation$data = {
  readonly store: {
    readonly sharedMobileDevice: {
      readonly update: {
        readonly id: string;
      };
    } | null;
  };
};
export type UserAdminEditGroupDeviceScreenMutation = {
  response: UserAdminEditGroupDeviceScreenMutation$data;
  variables: UserAdminEditGroupDeviceScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "SharedMobileDeviceMutations",
        "kind": "LinkedField",
        "name": "sharedMobileDevice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name"
              }
            ],
            "concreteType": "SharedMobileDevice",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminEditGroupDeviceScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAdminEditGroupDeviceScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ba370ce6dff72f8fa4d4c54a0842991b",
    "id": null,
    "metadata": {},
    "name": "UserAdminEditGroupDeviceScreenMutation",
    "operationKind": "mutation",
    "text": "mutation UserAdminEditGroupDeviceScreenMutation(\n  $id: ID!\n  $name: String!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    sharedMobileDevice(id: $id) {\n      update(name: $name) {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7eb35d5e93feb15da5635892b1e13e3b";

export default node;
